import React, { FC } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

interface ConfirmDiscardDialogProps {
  open: boolean;
  onKeepEditing: () => void;
  onDiscard: () => void;
}

export const ConfirmDiscardDialog: FC<ConfirmDiscardDialogProps> = ({
  open,
  onKeepEditing,
  onDiscard,
}) => (
  <Dialog open={open} onClose={onKeepEditing} maxWidth="xs">
    <DialogTitle>Discard your edits?</DialogTitle>
    <DialogContent dividers>
      <Typography variant="body2">
        You&apos;ve edited the new settings but haven&apos;t run the migration. Closing now discards
        those changes.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onKeepEditing}>Keep editing</Button>
      <Button color="error" onClick={onDiscard}>
        Discard &amp; close
      </Button>
    </DialogActions>
  </Dialog>
);
